import { BaseService, DataResponse, STATUS_OK, SuccessResponse } from "@/core/services/BaseService"
import { Family } from "@/model/family.model";
import { Reporting } from "@/model/reporting.model";
import { format } from 'date-fns'

const mapData = (families: Family[]): Family[] => families
  .map(f => ({
    ...f, members: f.members
      .map(m => ({ ...m, birth: format(new Date(m.birth), 'yyyy-MM-dd') }))
  }));

const formatFamily = (family: Family): Family => ({
  ...family, members: family.members.map(m => ({
    ...m, birth: new Date(m.birth).toISOString(),
  }))
});

class FamilyService extends BaseService {

  private families: Family[] = []

  public async getFamilies(): Promise<Family[]> {

    const res = await this.$http
      .get<DataResponse<Family[]>>(`/api/families`)
      .catch(error => error.response)

    this.families = mapData(res.status === STATUS_OK ? res.data.data : []);

    return this.families;
  }

  public async getReporting(): Promise<Reporting[]> {
    const res = await this.$http
      .get<DataResponse<Reporting[]>>(`/api/members/reporting`)
      .catch(error => error.response)

    return res.status === STATUS_OK ? res.data.data : [];
  }

  public async save(family: Family): Promise<Family[]> {
    const method = family.key ? 'put' : 'post';
    const res = await this.$http
    [method]<DataResponse<Family[]>>(`/api/families`, formatFamily(family))
      .catch(error => error.response)

    this.families = mapData(res.status === STATUS_OK ? res.data.data : []);

    return this.families;
  }

  public async delete(family: Family): Promise<{status: boolean, families: Family[]}> {
    const res = await this.$http.delete<SuccessResponse>(`/api/families/${family.key}`,)
      .catch(error => error.response)

    if (res.status === STATUS_OK) {
      this.families = this.families.filter(f => f.key !== family.key)
    }

    return { status: res.status === STATUS_OK, families: this.families };
  }

  public async deleteMembers(year: number): Promise<{status: boolean}> {
    const res = await this.$http.delete<SuccessResponse>(`/api/members/${year}`,)
      .catch(error => error.response)

    return { status: res.status === STATUS_OK };
  }

  public async register(family: Family): Promise<boolean> {
    const res = await this.$http.post<DataResponse<boolean>>(`/api/register`, formatFamily(family))
      .catch(error => error.response)

    return true;
  }


}

export default new FamilyService()
